import React, { useState } from "react";
import API from "../backend/api";
import { GoogleLogin } from "@react-oauth/google";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const res = await API.post("/login/", {
                username,
                password,
            });

            localStorage.setItem("access_token", res.data.access);
            localStorage.setItem("refresh_token", res.data.refresh);

            login({
                accessToken: res.data.access,
                refreshToken: res.data.refresh
            });
            
            navigate('/');
        } catch (err) {
            alert("Invalid credentials");
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            console.log("Google login successful, credential received:", credentialResponse);
            
            // Send JWT to Django
            const res = await API.post("/auth/google/", {
                token: credentialResponse.credential,
            });

            console.log("Backend response:", res.data);
            
            localStorage.setItem("access_token", res.data.access);
            localStorage.setItem("refresh_token", res.data.refresh);

            login({
                accessToken: res.data.access,
                refreshToken: res.data.refresh,
                user: res.data.user
            });
            
            navigate('/');
        } catch (err) {
            console.error("Google login error:", err);
            console.error("Error response:", err.response?.data);
            alert(`Google login failed: ${err.response?.data?.error || err.message}`);
        }
    };

    const handleGoogleError = () => {
        alert("Google login was unsuccessful. Please try again later.");
    }

    return (
        <div className="space-y-4">
            <form onSubmit={handleLogin} className="space-y-4">
                <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    className="border p-2 w-full"
                />
                <input
                    type="text"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="border p-2 w-full"
                />
                <button
                    type="submit"
                    className="bg-blue-500 text-white p-2 rounded w-full"
                >
                    Login
                </button>
            </form>

            <div className="text-center text-gray-500">or</div>

            <div className="flex justify-center">
                <GoogleLogin
                    onSuccess={handleGoogleSuccess}
                    onError={handleGoogleError}
                    useOneTap={false}
                    auto_select={false}
                    theme="outline"
                    size="large"
                    text="signin_with"
                    shape="rectangular"
                    width="300"
                />
            </div>
        </div>
    );
}

export default Login;